import { translate, translateFormatter } from '@/domains/core/localization/translate';
export const {
  addToWishlistMiniPopupMessage,
  addToWistListActionText,
  deletedFromWishlistMiniPopupMessage
} = translate({
  "addToWishlistMiniPopupMessage": "Product added to favorites",
  "deletedFromWishlistMiniPopupMessage": "Product removed from your list",
  "addToWistListActionText": "Add to a list"
});
export const addedToWishlistWithName = translateFormatter<{
  wishListName: string;
}>([{
  "type": 0,
  "value": "Product set aside in your list "
}, {
  "type": 1,
  "value": "wishListName"
}], undefined, undefined, "en");